/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "fvyacnktpjmbpbfeujkj"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ2eWFjbmt0cGptYnBiZmV1amtqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkwOTgwMDcsImV4cCI6MjA4NDY3NDAwN30.g0HZRQLj3zRCRmpptt0SB42pTRQm6bV5u86lhx-icD4"